import(/* webpackMode: "eager" */ "/vercel/path0/ui/src/app/earn/page.tsx");
